import axios, { AxiosInstance } from "axios";

export const BASE_URL = import.meta.env.VITE_DATABASE_URL;

export const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});
